(() => {
  const drawer = document.getElementById('Details-menu-drawer-container');
  const trigger = document.getElementById('HeaderDrawerSummary');
  const panel = document.getElementById('menu-drawer');
  trigger.setAttribute('aria-expanded','false');
  trigger.setAttribute('aria-controls','menu-drawer');
  panel.setAttribute('role','dialog');
  panel.setAttribute('aria-modal','true');
  panel.setAttribute('aria-label','Navigation');
  const setDrawer = (open, restore = false) => {
    drawer.open = open;
    drawer.classList.toggle('menu-opening', open);
    trigger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('tuffaha-nav-open', open);
    if (open) requestAnimationFrame(() => panel.querySelector('button,summary,a').focus());
    if (restore) trigger.focus();
  };
  trigger.addEventListener('click', e => { e.preventDefault(); e.stopImmediatePropagation(); setDrawer(!drawer.open); }, true);
  document.querySelector('[data-close-nav]').addEventListener('click', () => setDrawer(false, true));
  document.querySelectorAll('.tuffaha-macbooks').forEach(details => {
    const summary = details.querySelector('summary');
    details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    details.addEventListener('keydown', e => {
      if (e.key === 'Escape' && details.open) { e.preventDefault(); e.stopPropagation(); details.open = false; summary.focus(); }
      if (e.key === 'ArrowDown' && e.target === summary) { e.preventDefault(); details.open = true; details.querySelector('a').focus(); }
    });
  });
  document.addEventListener('click', e => document.querySelectorAll('.header__inline-menu .tuffaha-macbooks[open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }));
  document.addEventListener('keydown', e => {
    if (!drawer.open) return;
    if (e.key === 'Escape') { e.preventDefault(); setDrawer(false, true); }
    if (e.key === 'Tab') {
      const items = [...panel.querySelectorAll('button,summary,a')].filter(e => e.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.querySelectorAll('[data-nav-windows]').forEach(a => a.addEventListener('click', () => setDrawer(false)));
  matchMedia('(min-width: 1240px)').addEventListener('change', e => {if(e.matches) setDrawer(false);});
})();
